import { render, staticRenderFns } from "./OptimizationGroupCreate.vue?vue&type=template&id=22f8a406"
import script from "./OptimizationGroupCreate.vue?vue&type=script&lang=js"
export * from "./OptimizationGroupCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports